<!-- reports.component.html -->
<div class="report-container card screen-container">
  <div class="card-body">
    <div class="report-summary d-flex align-items-center justify-content-between">
      <div class="summary-left">
        <span class="muted">{{_appService.CoreCommonLiterals.MultiSelect_All_Male}}</span>
        <span class="count">(
          {{ _totalRowCount || _cloneFilteredArray?.RowCount || (_FilteredArray?.Rows?.length || 0) }}
        )</span>
        <span class="separator">|</span>
        <span class="muted">Seleccionados</span>
        <span class="count">({{ selectedCount }})</span>
        <button class="btn btn-secondary ml-2" type="button" (click)="resetParams()" [disabled]="!enableCleanFilter" [tooltip]="_appService.CoreCommonLiterals.ButtonClean" [tooltipPlacement]="'top'" [container]="'body'">
          <i class="fas fa-trash"></i>
        </button>
      </div>
      
    </div>

    <form #myForm="ngForm">
      <div class="d-flex align-items-center gap-3 filter-section py-3">
        <div class="flex-grow-1">
          <div class="col-12 pl-0">
            <div class="d-flex flex-row align-items-end gap-3 filter-row">
              <div class="form-group flex-container">
                <label for="search-text">{{_appService.CoreCommonLiterals.ButtonSearch}}</label>
                <i class="fa fa-search" *ngIf="!searchText"></i>
                <input id="search-text" type="text" class="form-control"
                  [placeholder]="_appService.CoreCommonLiterals.ButtonSearch" 
                  [(ngModel)]="searchText" 
                  name="searchText"
                  (input)="search($event)" 
                  #inputElement 
                  customFocus>
                <span class="input-group-append" *ngIf="searchText">
                  <button id="table-preferences" class="btn btn-default btn-secondary" type="button" (click)="searchText = ''; search($event)"><i class="fa fa-times"></i></button>
                </span>
              </div>
              <div class="form-group flex-container">
                <custom-select
                  [bordered]="true"
                  [(ngModel)]="sector"
                  [labelText]="gearAppService.GearCommonLiterals.Sector"
                  name="sector"
                  id="sector"
                  #sectorModel="ngModel"
                  [(sourceList)]="sectorList"
                  required>
                </custom-select>
              </div>
              <div class="form-group flex-container">
                <custom-select
                  [bordered]="true"
                  [(ngModel)]="locality"
                  [labelText]="apolusService.literals.Locality"
                  name="locality"
                  id="locality"
                  #localityModel="ngModel"
                  [(sourceList)]="localityList"
                  required>
                </custom-select>
              </div>
              <div class="form-group flex-container">
                <custom-select
                  [bordered]="true"
                  [(ngModel)]="address"
                  [labelText]="_appService.CoreCommonLiterals.Address"
                  name="address"
                  id="address"
                  #addressModel="ngModel"
                  [(sourceList)]="addressList"
                  required>
                </custom-select>
              </div>
              <div class="form-group flex-container">
                <custom-select
                  [bordered]="true"
                  [(ngModel)]="streetNumber"
                  [labelText]="_appService.CoreCommonLiterals.StreetNumber"
                  name="streetNumber"
                  id="streetNumber"
                  #streetNumberModel="ngModel"
                  [(sourceList)]="streetNumberList"
                  required>
                </custom-select>
              </div>
            </div>
          </div>
        </div>
        
        <div class="summary-actions d-flex gap-2 mt-3">
          <button class="btn btn-primary mt-3" type="button" (click)="execReport(myForm, null)">
            <i class="fas fa-play mr-1"></i> {{ _appService.CoreCommonLiterals.ReportExecute }}
          </button>
          <button class="btn btn-outline-primary mt-3" type="button" (click)="execReport(myForm, null)">
            <i class="fas fa-download mr-1"></i> {{ _appService.CoreCommonLiterals.Export }}
          </button>
          <button class="btn btn-outline-primary mt-3" type="button" 
            [tooltip]="!showAdvancedFilters ? 'Mostrar más filtros' : 'Ocultar filtros'" 
            [tooltipPlacement]="'top'"
            [container]="'body'"
            (click)="showMoreFilters()">
            <i class="fas fa-filter"></i>
          </button>
        </div>
      </div>
      <div class="advanced-filters-container my-3" [class.expanded]="showAdvancedFilters">
        <div class="advanced-filters">
          <div class="d-flex flex-row align-items-end gap-3 filter-row">
            <div class="form-group flex-container form-parameter-wrapper">
              <form-parameter
                [parameter]="_parameter"
                (parameterChange)="onDateSelectChange($event)"
                [adaptiveLayout]="true"
                name="dateRange"
                id="dateRange">
              </form-parameter>
            </div>
            <div class="form-group flex-container">
              <label for="device">Datos del medidor</label>
              <ss-multiselect-dropdown [texts]="_multiSelectTexts"
                name="deviceData"
                id="deviceData"
                #device{{i}}="ngModel"
                [settings]="_multiSelectSettings"
                [options]="_deviceDataList"
                [(ngModel)]="_selectedDeviceData">
              </ss-multiselect-dropdown>
            </div>
            <div class="form-group flex-container">
              <label for="device">Datos del lectura</label>
              <ss-multiselect-dropdown [texts]="_multiSelectTexts"
                name="readingData"
                id="readingData"
                #device{{i}}="ngModel"
                [settings]="_multiSelectSettings"
                [options]="_readingDataList"
                [(ngModel)]="_readingData">
              </ss-multiselect-dropdown>
            </div>
            <div class="form-group flex-container">
              <label for="device">Datos de la vávula</label>
              <ss-multiselect-dropdown [texts]="_multiSelectTexts"
                name="valveData"
                id="valveData"
                #valveData{{i}}="ngModel"
                [settings]="_multiSelectSettings"
                [options]="_valveDataList"
                [(ngModel)]="_valveData">
              </ss-multiselect-dropdown>
            </div>
            <div class="form-group flex-container">
              <label for="device">Estado de alertas</label>
              <ss-multiselect-dropdown [texts]="_multiSelectTexts"
                name="alertData"
                id="alertData"
                #alertData{{i}}="ngModel"
                [settings]="_multiSelectSettings"
                [options]="_alertDataList"
                [(ngModel)]="_alertData">
              </ss-multiselect-dropdown>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div #reportResultContainer class="table-responsive mt-4">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th class="checkbox-column">
              <div class="position-relative d-inline-block text-right mr-2" dropdown>
                <button id="btn-filter-list" class="btn btn-secondary dropdown-toggle d-flex align-items-center pl-2" dropdownToggle type="button" >
                  <div class="custom-control custom-checkbox mr-1 d-inline-block">
                    <input type="checkbox" class="custom-control-input" name="checkAll" [id]="'checkAll'" [(ngModel)]="allSelected" (change)="toggleSelectAll($event.target.checked)">
                    <label class="custom-control-label" [for]="'checkAll'"></label>
                  </div>
                </button>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-left dropdown-menu-lg-right" role="menu">
                  <li role="menuitem" [id]="'filter-menu-list-'+i" *ngFor="let item of menuButtonList; let i = index;" >
                    <a type="button" class="dropdown-item" [id]="item.value" (click)="dropdownMenuAction($event, item)"  style="text-transform: none;">
                      <i [attr.class]="'mr-2 fa-solid ' + item?.icon" *ngIf="item?.icon"></i>{{item.label}}
                    </a>
                  </li>
                </ul>
              </div>
            </th>

            <th *ngFor="let col of _reportDefinition?.Columns">
              {{ col.Title }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of _FilteredArray?.Rows; let i = index">
            <td class="checkbox-column">
              <div class="form-group mb-0">
                <div class="custom-control custom-checkbox pl-0">
                  <input
                    class="custom-control-input"
                    type="checkbox"
                    [id]="'report-row-checkbox-' + currentPageRowIds[i]"
                    [checked]="selectedRowIds.has(currentPageRowIds[i])"
                    (change)="toggleRowSelectionById(currentPageRowIds[i], $event.target.checked)"
                    aria-label="Seleccionar fila"/>
                  <label [for]="'report-row-checkbox-' + currentPageRowIds[i]" class="custom-control-label"></label>
                </div>
              </div>
            </td>

            <td *ngFor="let cell of row">{{ cell }}</td>
          </tr>

          <tr *ngIf="!_FilteredArray?.Rows || _FilteredArray.Rows.length === 0">
            <td [attr.colspan]="_reportDefinition?.Columns?.length + 1" class="text-center">
              <div class="d-flex flex-column align-items-center justify-content-center py-4" style="color: #888;">
                <i class="fas fa-database fa-2x mb-2"></i>
                <span>{{_appService.CoreCommonLiterals.NoDataFound}}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-sm-12 col-12 d-flex justify-content-sm-end align-items-end mt-4 overflow-auto flex-column flex-sm-row mb-5">
      <div class="form-group mx-2 mb-2 mb-sm-0">
        <label for="itemsPerPage" class="mr-2">{{_appService.CoreCommonLiterals.RowsPerPage}}</label>
        <select id="itemsPerPage" class="form-control" [(ngModel)]="_rowsNumber" (change)="onPageSizeChange()">
          <option *ngFor="let option of _itemsPerPageOptions" [value]="option">{{ option }}</option>
        </select>
      </div>
      <button id="reports-btn-start" [disabled]="_currentPageNumber <= 1" type="button" class="btn btn-secondary text-nowrap mr-2 mb-2 mb-sm-0" (click)="goToFirstPage()">
        <span>&lsaquo;</span> {{_appService.CoreCommonLiterals.FirstPage}}
      </button>
      <button
        id="reports-btn-previous"
        [disabled]="_currentPageNumber <= 1"
        type="button"
        class="btn btn-secondary text-nowrap mr-2 mb-2 mb-sm-0"
        (click)="movePage(-1)"
      ><span>&laquo;</span>  {{_appService.CoreCommonLiterals.PreviousPage}}
      </button>
      <span class="mx-2 text-nowrap mb-2 mb-sm-0" *ngIf="_totalPageCount >= 1">{{ _currentPageNumber }} / {{ _totalPageCount }}</span>
      <button
        id="reports-btn-next"
        [disabled]="_currentPageNumber >= _totalPageCount"
        type="button"
        class="btn btn-secondary mx-2 text-nowrap mb-2 mb-sm-0"
        (click)="movePage(1)"
      >
      {{_appService.CoreCommonLiterals.NextPage}} <span>&raquo;</span>
      </button>
      <button id="reports-btn-last"
      [disabled]="_currentPageNumber >= _totalPageCount"
      type="button"
      class="btn btn-secondary mx-2 text-nowrap mb-2 mb-sm-0"
      (click)="goToLastPage()"
      > {{_appService.CoreCommonLiterals.LastPage}} <span>&rsaquo;</span>
      </button>
      <span class="mx-2 text-nowrap mb-2 mb-sm-0" *ngIf="_firstTimeExecuted">Total registros: {{ _totalRowCount }}</span>
    </div>
  </div>
</div>
